// extracted by mini-css-extract-plugin
export default {"confirmation-modal__container":"ConfirmationModal_confirmation-modal__container__MCd4o"};